var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMenuDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 17,
    viewBox: "0 0 4 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2.50024,
    r: 2,
    fill: "#002438"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2.50024,
    r: 2,
    fill: "#002438",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 8.50024,
    r: 2,
    fill: "#002438"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 8.50024,
    r: 2,
    fill: "#002438",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 14.5002,
    r: 2,
    fill: "#002438"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 14.5002,
    r: 2,
    fill: "#002438",
    fillOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuDots);
export default __webpack_public_path__ + "static/media/icon-menu-dots.41e6db7841b461e5907e0212a2ee3df2.svg";
export { ForwardRef as ReactComponent };